import { Navigate, useLocation } from 'react-router-dom';
import { getCurrentUser, isAuthenticated } from '../hooks/useAuth';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const location = useLocation();
  if (!isAuthenticated()) return <Navigate to='/login' />;

  const user = getCurrentUser();
  if (user?.mustChangePassword && location.pathname !== '/change-password') {
    return <Navigate to='/change-password' replace />;
  }

  return <>{children}</>;
}
